import styled from "styled-components";

// Add some css to the modal-cookiews-popup .
export const CookiesStyles = styled.div`
  text-align: center;
  h4 {
    margin-bottom: 40px;
  }
  p {
    margin-bottom: 40px;
  }
  a {
    font-weight: bold;
  }
`;
